import { register } from "@shopify/theme-sections";
import Vue from "vue";
import "../vue/filters";
import { store } from "../vue/store";
import { ACTION_INIT_CART, ACTION_ADD_TO_CART } from "../vue/store/cart/cart";
import MinicartVue from "../vue/Minicart.vue";
import { templateEquals } from "@savchukoleksii/shopify-template-checker";

const selectors = {
	minicartOpener: ".js-open-minicart"
};

document.addEventListener("product:add", async function (event) {
	const detail = event.detail;

	if (!detail) {
		return null;
	}

	const items = detail.items;

	if (!items) {
		return null;
	}

	const errorCallback =
		typeof event.detail.errorCallback === "function"
			? event.detail.errorCallback
			: () => {};

	await store.dispatch(`cart/${ACTION_ADD_TO_CART}`, {
		products: event.detail.items,
		errorCallback
	});

	const callback = detail.callback;

	if (typeof callback === "function") {
		await callback();
	}

	document.dispatchEvent(new CustomEvent("minicart:open"));
});

if (!templateEquals("cart")) {
	register("minicart", {
		minicartOpeners: null,
		onLoad: function () {
			this.init();
		},
		init: async function () {
			await store.dispatch(`cart/${ACTION_INIT_CART}`);

			new Vue({
				store,
				render: (h) => h(MinicartVue)
			}).$mount(this.container);

			this.minicartOpeners = document.querySelectorAll(
				selectors.minicartOpener
			);

			this.initEvents();
		},
		initEvents: function () {
			if (!this.minicartOpeners) {
				return null;
			}

			this.minicartOpeners.forEach((opener) => {
				opener.addEventListener("click", this.open.bind(this));
			});
		},
		open: function (event) {
			event.preventDefault();

			document.dispatchEvent(new CustomEvent("minicart:open"));
		}
	});
}
